import React from 'react';
import { motion } from 'framer-motion';
import './Notepad.css';

const Notepad = ({ onCreate }) => {
  const handleClick = () => {
    // Create note at a random position further from the notepad
    const randomX = 400 + Math.random() * 300;
    const randomY = 200 + Math.random() * 250;
    onCreate({ x: randomX, y: randomY });
  };

  return (
    <motion.div
      className="notepad"
      whileHover={{ scale: 1.05, rotate: -2 }}
      whileTap={{ scale: 0.95 }}
      onClick={handleClick}
      title="Click to create a new note"
    >
      <svg
        className="notepad-svg"
        viewBox="0 0 200 250"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Notepad binding/spiral */}
        <rect
          x="10"
          y="10"
          width="180"
          height="230"
          fill="#f5e6d3"
          stroke="#a68a64"
          strokeWidth="2"
          rx="4"
        />

        {/* Spiral binding holes */}
        <g className="spiral-binding">
          {[...Array(12)].map((_, i) => (
            <circle
              key={i}
              cx={25 + i * 14}
              cy="20"
              r="3"
              fill="#6b5644"
              opacity="0.6"
            />
          ))}
        </g>

        {/* Lined paper effect */}
        <g className="notepad-lines">
          {[...Array(10)].map((_, i) => (
            <line
              key={i}
              x1="30"
              y1={60 + i * 18}
              x2="170"
              y2={60 + i * 18}
              stroke="#a68a64"
              strokeWidth="0.5"
              opacity="0.3"
            />
          ))}
        </g>

        {/* Decorative "Notes" text */}
        <text
          x="100"
          y="50"
          textAnchor="middle"
          fill="#6b5644"
          fontSize="14"
          fontFamily="var(--font-primary)"
          fontStyle="italic"
          opacity="0.5"
        >
          Notes
        </text>

        {/* Plus icon hint */}
        <g className="plus-icon" opacity="0.4">
          <circle cx="100" cy="140" r="20" fill="none" stroke="#6b5644" strokeWidth="2" />
          <line x1="100" y1="130" x2="100" y2="150" stroke="#6b5644" strokeWidth="2" />
          <line x1="90" y1="140" x2="110" y2="140" stroke="#6b5644" strokeWidth="2" />
        </g>

        {/* Paper texture */}
        <rect
          x="10"
          y="10"
          width="180"
          height="230"
          fill="url(#paperTexture)"
          opacity="0.3"
          rx="4"
        />

        <defs>
          <pattern id="paperTexture" x="0" y="0" width="4" height="4" patternUnits="userSpaceOnUse">
            <rect width="4" height="4" fill="transparent" />
            <circle cx="2" cy="2" r="0.5" fill="#a68a64" opacity="0.2" />
          </pattern>
        </defs>
      </svg>

    </motion.div>
  );
};

export default Notepad;
